<template>
  <loading-icon class="c-card" v-if="loading"></loading-icon>
  <section class="c-card c-card--leaderboard" v-else>


      <div class="c-card__header">
        <h2 class="c-card__title t-headline qa-leaderboard-title">{{ title }}</h2>
      </div>


      <div
        v-if   = "participantPosition !== null"
        class  = "c-card--leaderboard__summary"
        :class = "rankDigits"
      >
        <span class="c-card--leaderboard__summary__rank u-no-wrap t-rank qa-leaderboard-my-rank">
          <i class="fa fa-trophy c-card--leaderboard__summary__rank__icon t-ranked-trophy">
          </i>{{ formatNumber(participantPosition + 1) }}
        </span>

        <span class ="c-card--leaderboard__summary__rank-of u-no-wrap">
         &nbsp;of {{ formatNumber(card.recordsTotal) }}
        </span>
      </div>


      <div
        v-if  = "card.description !== null"
        class = "c-card--leaderboard__description qa-leaderboard-description"
      >
        <p>{{ card.description }}</p>
      </div>


      <h2
        v-if  = "dataNotAvailable"
        class = "c-card--leaderboard__missing-data qa-description-header"
      >
        {{ $t('web.card_leaderboard.data_not_available') }}
      </h2>


      <table
        v-else
        class = "c-card--leaderboard__table"
      >
        <thead>
          <tr>
            <th v-for = "field in card.headers">
              {{ field }}
            </th>
          </tr>
        </thead>


        <tbody>
          <tr v-for="record in leaderboards">
            <td
              v-if     = "record === '...'"
              :colspan = "columnsLength"
              class    = "c-card--leaderboard__collapsed-row"
            >&hellip;</td>

            <td
              v-if="record !== '...'"
              class="c-card--leaderboard__rank t-leaderboard-rank"
              :class= "myPosition(record, 1) ? 'qa-leaderboard-my-row-rank' : ''"
            >{{ formatNumber((record + 1)) }}</td>

            <td
              v-for = "(field, index) in reportData[card.report_id][record]"
              v-if  = "record !== '...' && typeof field.id === 'undefined'"
              class = "c-card--leaderboard__table__row"
              :class= "myPosition(record, index) ? 'qa-leaderboard-my-row-name' : ''"
            >
              {{  formatFieldValue(field, index)  }}
              <span
                v-if        = "myPosition(record, index)"
                class       = "fa fa-check-circle
                               c-card--leaderboard__table__icon__row__me
                               t-leaderboard-rank
                               qa-leaderboard-my-row-icon"
                aria-hidden = "false"><i class="u-hide">{{ $t('web.card_leaderboard.hidden_you_indicator') }}</i>
              </span>
            </td>
          </tr>
        </tbody>
      </table>


      <div class="c-card__footer u-center-content">
        <button
          class  = "c-button-expand-card qa-leaderboard-open-modal"
          @click = "openLeaderboardModal()"
        >
          {{ $t('web.card_leaderboard.button_open_full_list') }}
          &nbsp;<i class="fa fa-plus-square"></i>
        </button>
      </div>
  </section>
</template>




<script>
import { mapGetters } from 'vuex'
import $ from 'jquery'
import util from '@/functions'

export default {
  name: 'LeaderboardCard',
  props: ['card'],
  data () {
    return {
      participantPosition: null
    }
  },
  computed: {
    ...mapGetters({
      websiteConfig: 'websiteConfig',
      reportData: 'reportData',
      participant: 'participant'
    }),
    loading () {
      return !this.card.cardLoaded
    },
    title () {
      return this.card.title ? this.card.title : 'Leaderboard'
    },
    dataNotAvailable () {
      return typeof this.reportData[this.card.report_id] === 'undefined' || this.reportData[this.card.report_id] === null || this.reportData[this.card.report_id].length === 0
    },
    columnsLength () {
      if (typeof this.card.headers !== 'undefined') {
        return this.card.headers.length
      }
      return 0
    },
    /**
     * Creates an array with indexes to show the correct leaderboard list with the top 3 positions in case the current
     * participant is not in the list, it will show the top 3 if the current participant is in the top 3, in case
     * current participant is not in the top 3 but it's inside the list it will show the top 3 and the positions above
     * and below the current participant.
     *
     * @returns {Array}
     */
    leaderboards () {
      this.participantPosition = util.getParticipantPosition(this.participant.id, this.reportData[this.card.report_id])
      let records = []
      let first = 0
      let distance = 2
      // If participantPosition is inside the top 3 display only the top 3 or if the participantPosition is null
      // which means the current participant is not in the list, display the top 3
      if (this.participantPosition <= distance || this.participantPosition === null) {
        for (let i = first; i <= distance; i++) {
          records.push(i)
        }
        return records
      } else {
        for (let i = first; i <= distance; i++) {
          records.push(i)
        }
      }
      // If the participantPosition is more than the top 3 elements + the distance then it means it requires to
      // display an ellipsis
      if (this.participantPosition >= (records.length + distance)) {
        records.push('...')
      }
      // Adds the position above and below the current participantPosition
      for (let i = this.participantPosition - 1; i <= this.participantPosition + 1; i++) {
        if (records.indexOf(i) === -1 && typeof this.reportData[this.card.report_id][i] !== 'undefined') {
          records.push(i)
        }
      }
      return records
    },
    rankDigits () {
      let paxPosition = this.participantPosition + 1
      let rankPool = this.reportData[this.card.report_id].length
      let numberOfDigits = paxPosition.toString().length + rankPool.toString().length
      if (numberOfDigits >= 2 && numberOfDigits <= 12) {
        return 'has-' + numberOfDigits + '-digits'
      }
      return 'is-very-long'
    }
  },
  methods: {
    openLeaderboardModal () {
      $('body').addClass('has-modal')
      this.$store.commit('UPDATE_LEADERBOARD_MODAL_SHOW', true)
      this.$store.commit('UPDATE_LEADERBOARD_MODAL_DATA', this.card)
    },
/**
     * Returns true if the participant position matches the current leaderboard position
     * and the column is 1 (i.e. the first column after the position) or not passed
     */
    myPosition (leaderboardPosition, column = 1) {
      return this.participantPosition === leaderboardPosition && column === 1
    },
    formatNumber (value) {
      return util.formatNumber(value)
    },
    /**
     * Takes the field value and its column index and returns the formatted
     * value based on the column field type
     *
     * @param {string} value Field value
     * @param {number} index Column index
     * @return {string}
     */
    formatFieldValue (value, index) {
      let type = this.card.fields[index] && this.card.fields[index].type
      let numberTypes = ['integer', 'currency', 'decimal', 'percent']
      if (numberTypes.indexOf(type) !== -1) {
        return this.formatNumber(value)
      }
      return value
    }
  }
}
</script>



// WEBPACK FOOTER //
// Leaderboard.vue?07a7f01f